export enum QuoteCustomForm {
  SendToAdjuster = 'SendToAdjuster',
  AssignToEntryUserAndSend = 'AssignToEntryUserAndSend',
  SetBundleDurationDays = 'SetBundleDurationDays',
  ReceiveInvoicePayment = 'ReceiveInvoicePayment',
  CreateAdditionalQuote = 'CreateAdditionalQuote',
  ClearReconciliationData = 'ClearReconciliationData',
  UnConsumeQuote = 'UnConsumeQuote',
}
